export enum ProjectOrigin {
  STANDALONE = 'STANDALONE',
  PLANNING_SUITE = 'PLANNING_SUITE'
}
